import React from 'react';
import PropTypes from 'prop-types';
import DocumentTitle from 'react-document-title';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import { authorize } from '../actions';
import { appNamedRoutes, isValidAuth } from '../routes';
import Error from '../components/Error';
import SparklerLogo from '../../assets/images/sparkler-logo.svg';

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      privacyAccepted: false,
    };
    this.onAcceptPrivacyChange = this.onAcceptPrivacyChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onAcceptPrivacyChange() {
    this.setState({
      privacyAccepted: !this.state.privacyAccepted,
    });
  }

  onSubmit(e) {
    e.preventDefault();

    if (!this.state.privacyAccepted) {
      return;
    }

    const email = this.email.value;
    const password = this.password.value;
    this.props.onAuth(email, password);
  }

  render() {
    const { from } = this.props.location.state || { from: { pathname: appNamedRoutes.root } };
    const { authExpires, isAuthenticated } = this.props;

    if (isValidAuth(isAuthenticated, authExpires)) {
      return <Redirect to={from} />;
    }

    return (
      <DocumentTitle title='Sparkler'>
        <div className="cs-bg--sp-black o-login__wrap">
          <form className="row o-login align-middle" onSubmit={this.onSubmit}>
            <div className="o-login__input o-login__logo u-margin-bottom--base">
              <Link to={appNamedRoutes.login}>
                <img alt='' src={SparklerLogo} />
              </Link>
            </div>
            <div className="o-login__input">
              <input
                name='sp-login-email'
                ref={_ref => this.email = _ref}
                autoCapitalize="none"
                type="email"
                placeholder="Email"
              />
            </div>
            <div className="o-login__input">
              <input
                name='sp-login-password'
                ref={_ref => this.password = _ref}
                type="password"
                placeholder="Password"
              />
            </div>
            <div className="o-login__input o-login__paragraph_checkbox">
              <input
                type="checkbox"
                name="sp-login-accept-privacy"
                id="sp-login-accept-privacy"
                ref={_ref => this.acceptPrivacy = _ref}
                onChange={this.onAcceptPrivacyChange}
                checked={this.state.privacyAccepted}
              />
              <label className="cs-txt--light o-login__input--label" htmlFor="sp-login-accept-privacy">
                By continuing, I affirm my commitment to privacy and security.
                <br />
                {'I agree to Sparkler\'s'} <a href="https://playsparkler.org/content/privacy-policy" target="_blank" rel="noreferrer">Privacy Policy</a> and <a href="https://playsparkler.org/content/terms-service" target="_blank" rel="noreferrer">Terms of Service</a>.
              </label>
            </div>
            <div className="o-login__input u-flex u-flex-gap u-flex-center u-flex-column">
              <button type="submit" disabled={!this.state.privacyAccepted} className="o-sp-button o-sp-button--primary o-sp-button--login o-sp-button--block">
                Login
              </button>
            </div>
            <div className="o-login__input u-margin-top--base">
              <hr className="u-margin-bottom--small" />
              <Link to={appNamedRoutes.forgotPassword} className="cs-txt-link--light u-float--left">Reset password</Link>
            </div>
          </form>
        </div>
      </DocumentTitle>
    );
  }
}

const mapStateToProps = state => ({
  authExpires: state.auth.authExpires,
  isAuthenticated: state.auth.isAuthenticated,
});

const mapDispatchToProps = (dispatch) => {
  return {
    onAuth: (login, password) => {
      dispatch(authorize(login, password));
    },
  }
}

Login.propTypes = {
  authExpires: PropTypes.string,
  isAuthenticated: PropTypes.bool.isRequired,
  from: PropTypes.object,
  onAuth: PropTypes.func.isRequired,
  location: PropTypes.object,
}

export default connect(mapStateToProps, mapDispatchToProps)(Login)
